<template>
  <v-card>
    <v-toolbar class="card-bar">
      <v-toolbar-title>Rendered bytes</v-toolbar-title>

      <v-btn icon @click="copyToClipboard" class="ml-8">
        <v-icon>mdi-clipboard-outline</v-icon>
      </v-btn>

      <v-spacer />
    </v-toolbar>
    <v-card-text>
      <pre class="mono">{{ formattedBytes }}</pre>
    </v-card-text>
  </v-card>
</template>

<script>
import InspectorStore from './InspectorStore'
import brush from 'brush'

export default {
  computed: {
    formattedBytes() {
      return brush.toHex(InspectorStore.bytes, {
        prettyPrint: true,
        bytesPerLine: 64,
        groupSep: '  ',
        groupSize: 4
      })
    }
  },
  methods: {
    copyToClipboard() {
      navigator.clipboard.writeText(this.formattedBytes)
      this.$snack(`Copiado para a área de transferência`)
    },
    openMiniParser() {}
  }
}
</script>

<style></style>
